import APIService from "../../helper/api-service";
import { IApiResponse } from "../../models/IAPIResponse";
import { ITrainingMatrics } from "../../models/staff";
import { staffTraining, StaffTrainingRegisterAndAttend } from "../../constants/apiUrl";
import { urlBinder } from "../../helper/url-binder";

export default new (class TrainingCompletionDetailsService {
    public getTrainingCompletionDetails = async (): Promise<IApiResponse<ITrainingMatrics>> => {
      try {
        let endPoint = staffTraining.TRAINING_COMPLETION_DETAILS;        
        const response = await APIService.get(endPoint);
        return response.data as IApiResponse<ITrainingMatrics>;
      } catch (error: any) {
        if (error.response) {
          return error.response as IApiResponse<ITrainingMatrics>;
        } else {
          throw error;
        }
      }
    }
    public updateTrainingRegisterAndAttend = async (
      id: number
    ): Promise<IApiResponse<boolean>> => {
      try {
        let endPoint = urlBinder(StaffTrainingRegisterAndAttend.GET_STAFF_TRAINING_REGISTER_AND_ATTEND, [`${id}`]);        
        const response = await APIService.get(endPoint);
        return response.data as IApiResponse<boolean>;
      } catch (error: any) {
        if (error.response) {
          return error.response as IApiResponse<boolean>;
        } else {
          throw error;
        }
      }
    }
  });